import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(public)/(policies)/cgu")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <section className="max-container mt-10 mx-auto px-4 font-outfit">
      <h1 className="font-bold text-[#17365d] text-5xl max-md:text-2xl mb-5">
        Conditions Générales d&apos;Utilisation (CGU) de HomeToq
      </h1>
      <hr className="h-0.5 bg-dark-blue rounded-full mb-5" />

      <div>
        <h2 className="text-[#356091] font-bold text-xl">Préambule</h2>
        <p>
          HomeToq SAS est une société par actions simplifiée au capital de 10
          000 euros, immatriculée au registre du commerce et des sociétés de
          Perpignan sous le numéro 927 511 287, dont le siège social est situé
          au 6 Rue des Potiers, 66240 Saint-Estève, France. La plateforme
          HomeToq propose un service de mise en relation entre des chefs à
          domicile et des clients pour des prestations culinaires.
          <br />
          <br />
          Les présentes Conditions Générales d&apos;Utilisation (CGU) régissent
          l&apos;accès et l&apos;utilisation de la plateforme HomeToq par les
          chefs (Prestataires) et les clients (Utilisateurs).
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 1 : Définitions
        </h2>
        <p>
          Dans le cadre des présentes CGU, les termes et expressions identifiés
          par une majuscule ont les significations suivantes : <br />-{" "}
          <strong>&ldquo;La Société&rdquo;</strong> désigne HomeToq SAS. <br />-{" "}
          <strong>&ldquo;Prestataire&rdquo;</strong> se réfère à tout chef à
          domicile utilisant la plateforme HomeToq pour proposer ses services
          culinaires. <br />- <strong>&ldquo;Plateforme&rdquo;</strong> désigne
          le site internet exploité par la Société accessible à l&apos;adresse
          www.hometoq.com, incluant toutes ses versions mobiles et applications
          dérivées. <br />- <strong>&ldquo;Services&rdquo;</strong> se réfère
          aux prestations culinaires proposées par les Prestataires à travers la
          Plateforme. <br />- <strong>&ldquo;Utilisateur&rdquo;</strong> désigne
          toute personne utilisant la Plateforme pour rechercher, comparer et
          réserver les Services offerts par les Prestataires. <br />-{" "}
          <strong>&ldquo;Réservation&rdquo;</strong> signifie l&apos;acte par
          lequel un Utilisateur s&apos;engage à acheter des Services auprès
          d&apos;un Prestataire via la Plateforme.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 2 : Acceptation des CGU
        </h2>
        <p>
          En accédant ou en utilisant la Plateforme, l&apos;Utilisateur accepte
          les présentes CGU. Si l&apos;Utilisateur refuse de se conformer à ces
          conditions, il doit cesser immédiatement l&apos;utilisation de la
          Plateforme.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 3 : Utilisation de la Plateforme
        </h2>
        <p>
          <strong>3.1 Création de Compte</strong> <br />
          Pour accéder aux Services proposés par la Plateforme,
          l&apos;Utilisateur doit créer un compte en fournissant des
          informations exactes et complètes. <br />
          L&apos;Utilisateur est responsable de la confidentialité de ses
          identifiants et de toutes les activités menées sous son compte.
          <br />
          <br />
          <strong>3.2 Sélection des Prestataires</strong> <br />
          La Plateforme propose une liste de Prestataires avec des informations
          détaillées sur leurs Services. <br />
          L&apos;Utilisateur peut consulter les profils des Prestataires,
          comparer les offres et effectuer une Réservation.
          <br />
          <br />
          <strong>3.3 Réservation</strong> <br />
          Les Réservations doivent être effectuées en suivant le processus
          établi par la Plateforme. <br />
          Le Prestataire doit accepter ou refuser la Réservation dans un délai
          raisonnable.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 4 : Engagements des Utilisateurs
        </h2>
        <p>
          - Fournir des informations exactes lors de la création du compte et
          des Réservations. <br />
          - Ne pas utiliser la Plateforme à des fins illégales ou non
          autorisées. <br />- Respecter les droits de propriété intellectuelle
          de la Société et des Prestataires.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 5 : Engagements des Prestataires
        </h2>
        <p>
          - Respecter les standards de qualité et de sécurité établis par la
          Société. <br />
          - Fournir des Services conformes aux descriptions fournies sur la
          Plateforme. <br />- Maintenir à jour les informations relatives à leur
          disponibilité, leurs menus et leurs tarifs.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 6 : Paiements et Commissions
        </h2>
        <p>
          <strong>6.1 Paiements</strong> <br />
          Les Utilisateurs effectuent les paiements directement via la
          Plateforme. <br />
          La Société est responsable de la collecte des paiements et du
          transfert des montants dus aux Prestataires après déduction de la
          Commission.
          <br />
          <br />
          <strong>6.2 Commission</strong> <br />
          La Commission due à la Société par le Prestataire est prélevée
          directement sur le montant total des Services réservés.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 7 : Modalités de Remboursement et d&apos;Annulation
        </h2>
        <p>
          <strong>7.1 Annulation par l&apos;Utilisateur</strong> <br />-{" "}
          <strong>Plus de 72 heures avant la prestation :</strong> Remboursement
          intégral (100 %). <br />-{" "}
          <strong>Entre 72 et 48 heures avant la prestation :</strong>{" "}
          Remboursement de 50 %. <br />-{" "}
          <strong>Moins de 48 heures avant la prestation :</strong> Aucun
          remboursement.
          <br />
          <br />
          <strong>
            7.2 Annulation pour les Prestations de Plus de 1 250 Euros
          </strong>{" "}
          <br />- <strong>0 à 7 jours avant la prestation :</strong> Aucun
          remboursement. <br />-{" "}
          <strong>7 à 14 jours avant la prestation :</strong> Remboursement de
          50 %. <br />- <strong>Plus de 14 jours avant la prestation :</strong>{" "}
          Remboursement intégral (100 %).
          <br />
          <br />
          <strong>7.3 Annulation par le Prestataire</strong> <br />
          Si un Prestataire annule une prestation confirmée, la Plateforme
          s&apos;efforcera de trouver un autre chef qualifié. Si aucun
          remplaçant n&apos;est trouvé, l&apos;Utilisateur sera remboursé
          intégralement.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 8 : Propriété Intellectuelle
        </h2>
        <p>
          <strong>8.1 Droits de Propriété Intellectuelle du Prestataire</strong>{" "}
          <br />
          Le Prestataire conserve tous les droits de propriété intellectuelle
          sur ses recettes, photos, vidéos, textes et tout autre matériel fourni
          à la Plateforme.
          <br />
          <br />
          <strong>
            8.2 Droits de Propriété Intellectuelle de la Société
          </strong>{" "}
          <br />
          La Société conserve tous les droits de propriété intellectuelle sur la
          Plateforme HomeToq.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 9 : Limitation de Responsabilité
        </h2>
        <p>
          - La Société ne sera en aucun cas responsable envers les Prestataires
          ou les Utilisateurs pour toute perte de profits, de revenus ou pour
          tout dommage indirect. <br />- La responsabilité totale de la Société
          ne dépassera pas le montant total des paiements versés ou dus au
          Prestataire sous ce contrat pendant les 12 mois précédant
          l&apos;événement.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 10 : Règlement des Litiges
        </h2>
        <p>
          <strong>10.1 Médiation</strong> <br />
          Avant d&apos;engager toute procédure judiciaire, les parties
          s&apos;engagent à tenter de résoudre tout litige par la médiation.
          <br />
          <br />
          <strong>10.2 Procédure Judiciaire</strong> <br />
          Si la médiation échoue, les parties peuvent soumettre le litige à la
          juridiction compétente.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 11 : Dispositions Générales
        </h2>
        <p>
          <strong>11.1 Modifications des CGU</strong> <br />
          Toute modification des présentes CGU doit être faite par écrit et
          signée par les deux parties.
          <br />
          <br />
          <strong>11.2 Loi Applicable et Juridiction</strong> <br />
          Ces CGU sont régies par le droit français. Tout litige sera soumis à
          la juridiction exclusive des tribunaux compétents de Perpignan.
        </p>
        <br />
        <br />
      </div>
    </section>
  );
}
